// The backend (OpportunityControllerHandler.updateOpportunityStatus) stores an enquiry's status
// comment as CANCEL_COMMENT_PREFIX + the text in opportunities.status_comment, varchar(500).
// The prefix is added there, not here; the text the user types must leave room for it.
export const CANCEL_COMMENT_PREFIX = 'CANCELLATION // '
export const STATUS_COMMENT_COLUMN = 500
export const CANCEL_COMMENT_MAX = STATUS_COMMENT_COLUMN - CANCEL_COMMENT_PREFIX.length
